module.exports = __webpack_public_path__ + "static/media/logo-ppid-kkp.861e97e8.png";